import * as ep from "../../endpoints";
import api from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    total_row:null,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    total_row(state){
      return state.total_row
    },

  },
  mutations: {
    setJobs(state, payload) {
      state.jobs = payload;
    },
  },
  actions: {
    async updateProcedures(context, payload) {
      context.state.loading = true;
      await api.put(ep.PROCEDURE_BY_ID(payload.id), payload.fd).then((res) => {
        context.state.loading = false;
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message,
            icon: res.data.status ? "CheckIcon": "XIcon",
            variant: res.data.status ? "success" :"danger",
          },
        });
      }).catch((err) => {
        console.log(err);
        context.state.loading = false;
      })
      .finally(() => {
        context.state.loading = false;
      });;
    },
    async createProcedures(context, payload) {
      context.state.loading = true;
      await api
        .post(ep.PROCEDURE, payload.fd)
        .then((res) => {
          context.state.loading = false;
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: res.data.status ? "CheckIcon": "XIcon",
              variant: res.data.status ? "success" :"danger",
            },
          });
        })
        .catch((err) => {
          console.log(err);
          context.state.loading = false;
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async deleteProcedures(context, payload) {
      context.state.loading = true;
      await api.delete(ep.PROCEDURE_BY_ID(payload.id)).then((res) => {
        context.dispatch("getJobs",{
          page: payload.page,
          per_page: payload.per_page,
          filter: payload.filter,
          type_id: payload.type_id,
        })
        context.state.loading = false;
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message,
            icon: res.data.status ? "CheckIcon": "XIcon",
            variant: res.data.status ? "success" :"danger",
          },
        });
      });
    },
  },
};
